type CheckmarkProps = {
  className?: string;
};

const Checkmark = ({ className }: CheckmarkProps) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="40" cy="40" r="39" stroke="#1C7B7C" strokeWidth="2" />
    <path
      d="M27 42.5424L34.3333 50L54 30"
      stroke="#1C7B7C"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default Checkmark;
